import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa'
import phcsLogo from 'images/content/logo/PHCS.png'

const SixthSection = () => {
    return (
        <>
            <div className='w-full space-y-4'>
                <div className='flex justify-center'>
                    <img src={phcsLogo} alt='phcsLogo' />
                </div>
                <div className='text-2xl sm:text-4xl font-bold text-center'>Welcome to the MultiPlan PHCS Network</div>
                <div className='space-y-4 sm:text-lg'>
                    <p>With the PHCS Network, you choose any doctor within the PPO network. You get an additional opportunity to save your healthcare dollars without sacrificing benefits.. MultiPlan’s PHCS Limited Benefit Network gives you discounted access to</p>
                    <ul>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> Qualified doctors</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> Healthcare facilities</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> Labs</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> Imaging centers</li>
                        <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 min-w-4 md:mx-2 mt-1 sm:mt-0 text-secondary' /> Hospitals</li>
                    </ul>
                    <p>Multiplan is one of the oldest and largest healthcare networks in the U.S. Currently, MultiPlan contracts with over 770,000 respected practitioners, 5,000 hospitals, and 70,000 ancillary care facilities, making it easier than ever to find a participating healthcare provider in your area. You save an average of 20-30% off inpatient and outpatient hospital charges when you use the MultiPlan Network.</p>
                </div>
            </div>
        </>
    );
}

export default SixthSection;
